import axios from "@/axios"

const url = "/api/brain/encaste/depuration/reasons/"

class DepurationReasonsService {
	async getReasons() {
		try {
			const data = await axios.get(`${url}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async getActiveReasons() {
		try {
			const data = await axios.get(`${url}active`)
			return data
		} catch (error) {
			throw error
		}
	}

	async storeReason({ name }) {
		try {
			const { data } = await axios.post(`${url}`, {
				name,
			})
			return data
		} catch (error) {
			throw error
		}
	}

	async editReason({ id, name }) {
		try {
			const data = await axios.put(`${url}${id}`, { name })
			return data
		} catch (error) {
			throw error
		}
	}

	async deleteReason({ id }) {
		try {
			const data = await axios.delete(`${url}${id}`)
			return data
		} catch (error) {
			throw error
		}
	}

	async updateStatus(id) {
		try {
			const data = await axios.put(`${url}active/${id}`)
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new DepurationReasonsService()
